import { ReactNode } from "react";
import { GOOGLE_OAUTH_CLIENT_ID } from "../../store/utils";
import { GoogleOAuthProvider } from "@react-oauth/google";

export const GoogleAuthProvider = ({ children }: { children: ReactNode }) => (
  <GoogleOAuthProvider clientId={GOOGLE_OAUTH_CLIENT_ID}>
    {children}
  </GoogleOAuthProvider>
);
